import * as React from "react";
import type { SVGProps } from "react";
const SvgContractPreviewEmptyState = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={79}
    height={69}
    fill="none"
    viewBox="0 0 79 69" {...props}
  >
    <g clipPath="url(#ContractPreviewEmptyState_svg__a)">
      <path
        fill="url(#ContractPreviewEmptyState_svg__b)"
        d="m.49 30.577 26.758 37.424c.637.901 1.764 1.218 2.72.78L66.944 51.7c1.47-.682 1.887-2.729.858-4.044l-27.665-35.11c-.637-.803-1.666-1.096-2.573-.73L1.52 26.606c-1.47.609-1.984 2.631-1.004 3.996z"
        opacity={0.7}
      />
      <path
        fill="#fff"
        stroke="#00217B"
        strokeMiterlimit={10}
        strokeWidth={0.641}
        d="M3.651 25.826c-.343.146-.49.61-.294.975.956 1.73 4.117 6.992 13.06 18.76 10.464 13.79 18.55 16.739 21.246 15.764l34.648-17.47c.514-.267 1.004-1.729-1.348-2.825-3.43-1.608-10.953-4.97-18.55-13.913-7.595-8.941-10.854-12.571-11.834-13.79-.172-.195-2.573-1.949-2.794-1.851z"
      />
      <path
        fill="#61B8EB"
        d="m28.377 15.69-15.462 6.433-2.083-2.704 5.783-2.388 1.593-.658 1.274-.536 1.495-.61 5.194-2.143z"
      />
      <path
        fill="#61B8EB"
        d="M18.303 12.767c-1.47 0-2.647 1.072-2.647 2.412s.368 1.389.931 1.852a2.75 2.75 0 0 0 1.716.585c1.445 0 2.622-1.072 2.646-2.388v-.049c0-1.34-1.176-2.412-2.646-2.412m-.098 3.606c-.735-.049-1.348-.634-1.348-1.316s.662-1.315 1.446-1.315 1.445.584 1.445 1.315-.098.56-.294.804l-1.274.536z"
      />
      <path
        fill="#7DADFF"
        d="M35.58 56.671c4.117-2.12 6.248-6.651 6.836-11.037.589-4.385.245-2.46.172-3.679s-.392-2.436-1.52-2.948c-1.102-.511-2.082.17-2.597 1.145-.514.975-.882 2.242-1.078 3.387-.367 2.241-.049 4.63 1.544 6.335.686.73 1.593 1.267 2.622 1.388 1.029.122 2.328-.268 3.283-.925 1.593-1.097 2.671-2.875 3.063-4.751s.245-1.998.074-2.973c-.172-.974-.54-2.266-1.691-2.242s-1.421 1.56-1.348 2.486c.074.926.441 2.07 1.078 2.9.638.828 1.495 1.437 2.524 1.68 1.03.244 2.083.073 3.014-.39.931-.462.858-.536 1.201-.901.539-.56-.319-1.438-.858-.853-1.078 1.12-2.842 1.389-4.14.487-1.3-.901-1.103-1.145-1.349-1.851-.244-.707-.22-.78-.244-1.194-.025-.414-.025-.731.122-1.048.147-.316.074-.146.049-.073s.024 0 .024 0c0 .049-.097-.097-.024 0 .073.098.098.122.147.195.196.317.245.731.319 1.096a6.5 6.5 0 0 1-.05 2.29c-.294 1.511-1.078 2.998-2.303 3.972-1.225.975-1.495.902-2.352.926-.858.024-1.47-.292-2.01-.804-1.323-1.218-1.69-3.07-1.543-4.8s.367-2.046.735-2.997c.367-.95.539-1.632 1.2-1.413.662.22.907 1.389.932 2.12.024 1.023 0 2.07-.147 3.094-.441 3.655-2.034 7.48-5.17 9.673-.368.243-.736.463-1.128.682-.71.365-.073 1.413.613 1.048z"
        opacity={0.4}
      />
      <path
        fill="#FFCE00"
        d="M73.61 10.89 51.508 33.648c-.637.658-1.74 2.388-2.01 3.314l-2.842 6.432 7.866-3.216c1.372-.999 2.377-1.925 3.014-2.607L79 14.716s-.171-1.9-2.01-3.41c-1.96-1.633-3.38-.415-3.38-.415"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.641}
        d="M72.066 12.791c.441.025.834.268 1.201.536a12 12 0 0 1 3.308 3.606"
      />
      <path
        fill="#000"
        d="M48.813 38.617s1.176-.462 2.18.56c1.005 1 .785 2.17.785 2.17l-5.122 2.07 2.157-4.775z"
      />
      <path
        stroke="#7DADFF"
        strokeMiterlimit={10}
        strokeWidth={0.961}
        d="m12.547 32.088 27.542-12.231M14.727 34.963l27.542-12.231M16.98 38.203l27.567-12.23M33.79 35.11l13.55-6.506"
        opacity={0.6}
      />
    </g>
    <defs>
      <linearGradient
        id="ContractPreviewEmptyState_svg__b"
        x1={9.483}
        x2={61.992}
        y1={9.892}
        y2={76.552}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#228FE6" />
        <stop offset={0.2} stopColor="#1AA0E0" />
        <stop offset={0.3} stopColor="#0DBBD6" />
        <stop offset={0.4} stopColor="#00DACB" />
        <stop offset={0.8} stopColor="#00DACB" stopOpacity={0.4} />
        <stop offset={1} stopColor="#00DACB" stopOpacity={0} />
      </linearGradient>
      <clipPath id="ContractPreviewEmptyState_svg__a">
        <path fill="#fff" d="M0 0h79v69H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgContractPreviewEmptyState;
